<!-- FAB button — fixed bottom-right -->
<button
  rds-fab-button
  class="filter-fab"
  (click)="togglePanel()"
  rdsTooltip="Filters"
>
  <rds-icon icon="filter" namespace="outlined"></rds-icon>
</button>

<!-- Filter panel — fixed overlay with slide animation -->
@if (panelOpen) {
  <div class="filter-panel-backdrop" @fadeBackdrop (click)="togglePanel()"></div>
  <div class="filter-panel" @slidePanel>
    <div class="filter-panel-header">
      <h3 class="drawer-title">Filters</h3>
      <button rds-icon-button size="s" (click)="togglePanel()">
        <rds-icon icon="close" namespace="outlined"></rds-icon>
      </button>
    </div>

    <!-- Entity type toggles -->
    <div class="entity-toggles">
      <h4 class="section-label">Show</h4>
      @for (toggle of entityToggles; track toggle.id) {
        <rds-switch
          [checked]="toggle.checked"
          (buttonChanged)="onEntityToggle(toggle.id)"
          size="s"
        >
          {{ toggle.label }}
        </rds-switch>
      }
    </div>

    <!-- Advanced filters form -->
    @if (filterForm) {
      <div class="advanced-filters">
        <h4 class="section-label">Advanced</h4>
        <form
          [formGroup]="filterForm"
          (ngSubmit)="applyFilters()"
          (beforeinput)="blockEnter($event)"
        >
          <rds-form-field id="timespan" (click)="rangePicker.open()">
            <rds-control-label>Timespan</rds-control-label>
            <rds-date-range-input
              [rangePicker]="rangePicker"
              [formGroup]="filterForm.controls.timespan"
              [dateFilter]="inTimespanBounds"
            >
              <input rdsStartDate placeholder="Start date" formControlName="start" />
              <input rdsEndDate placeholder="End date" formControlName="end" />
            </rds-date-range-input>
            <rds-datepicker-toggle rds-control-suffix />
            <rds-date-range-picker #rangePicker></rds-date-range-picker>
          </rds-form-field>

          @if (!features.isDiagnostics()) {
            <app-dynamic-filter-autocompletion
              elementID="studies"
              label="Studies"
              [control]="filterForm.controls.studies"
              type="studies"
            ></app-dynamic-filter-autocompletion>

            <app-dynamic-filter-autocompletion
              elementID="persons"
              label="Authors/Participants"
              [control]="filterForm.controls.persons"
              type="persons"
            ></app-dynamic-filter-autocompletion>

            <app-dynamic-filter-autocompletion
              elementID="targets"
              label="Targets"
              [control]="filterForm.controls.targets"
              type="targets"
            ></app-dynamic-filter-autocompletion>
          }

          @if (features.isEnabled('strategicPillars')) {
            <app-dynamic-filter-autocompletion
              elementID="strategic-pillars"
              label="Strategic Pillars"
              [control]="filterForm.controls.strategicPillars"
              [staticOptions]="allPillars"
              type="strategic-pillars"
            ></app-dynamic-filter-autocompletion>
          }

          @if (features.isEnabled('audiences')) {
            <app-dynamic-filter-autocompletion
              elementID="audiences"
              label="Audiences"
              [control]="filterForm.controls.audiences"
              [staticOptions]="allAudiences"
              type="audiences"
            ></app-dynamic-filter-autocompletion>
          }
        </form>
      </div>
    }

    <!-- Action buttons -->
    <div class="drawer-actions">
      <button rds-primary-button type="button" (click)="applyFilters()" size="m">
        @if (!loading) {
          Apply
        } @else {
          <rds-progress-spinner label="Updating..." size="m" white></rds-progress-spinner>
        }
      </button>
      <button rds-secondary-button type="button" (click)="clearFilters()" size="m">
        Clear
      </button>
    </div>
  </div>
}
